import { useFlag } from "hooks";
import React, { useEffect, useState } from "react";
import { View, FlatList, TouchableOpacity } from "react-native";

import Text from "components/Text";
import Icon from "components/Icon";
import Separator from "components/Separator";
import ModalInfinityList from "components/ModalInfinityList";

import { colors, sizes, strings } from "assets/constants";
import { styles } from "./styles";
import Button from "components/Button";

type Item = { id: number; title?: string; name?: string; text?: string };

type Props = {
  icon?: IconT;
  data: Array<Item>;
  value: Array<Item>;
  placeholder?: string;
  onApply: (cities: Array<Item>) => void;
};

const MultiSelector: React.FC<Props> = (props) => {
  const { flg: modal, on: showModal, off: hide } = useFlag();

  const { data, value, onApply, icon, placeholder } = props;

  const [valueState, setValueState] = useState<Array<Item>>([]);
  useEffect(() => setValueState(value), [value]);

  const _onApply = () => {
    onApply(valueState);
    hide();
  };

  const _renderItem = (args: { item?: Item }) => {
    const item = args.item;

    const itemIndex = valueState?.findIndex((e) => e?.id === item?.id);
    const active = itemIndex > -1;
    const _onPress = () => {
      active
        ? setValueState(valueState?.filter((e) => e.id !== item.id))
        : setValueState((prev) => [...prev, item]);
    };

    return (
      <TouchableOpacity
        activeOpacity={sizes.tapOpacity}
        style={{
          ...styles.item,
          backgroundColor: active ? colors.theme : colors.white,
        }}
        onPress={_onPress}
      >
        <Text color={active ? colors.white : colors.text.normal}>
          {item?.title ?? item?.name}
        </Text>

        {active && (
          <View style={{ position: "absolute", left: 10 }}>
            <Icon type="antDesign" name={"close"} color={colors.white} />
          </View>
        )}
      </TouchableOpacity>
    );
  };

  return (
    <>
      <>
        <TouchableOpacity
          onPress={showModal}
          style={styles.inputContainer}
          activeOpacity={sizes.tapOpacity}
        >
          <View style={styles.iconContainer}>
            <Icon name="chevron-down" />
          </View>
          <View style={styles.textContainer}>
            <Text>{placeholder || "یک یا چند مورد انتخاب و اعمال کنید"}</Text>
          </View>
          {icon && (
            <View style={styles.iconContainer}>
              <Icon {...icon} />
            </View>
          )}
        </TouchableOpacity>
      </>

      <ModalInfinityList visible={modal} close={hide}>
        {data && data?.length > 0 && (
          <FlatList
            nestedScrollEnabled
            maxToRenderPerBatch={10}
            data={data}
            keyExtractor={(_, key) => String(key)}
            renderItem={_renderItem}
            style={{ width: "100%" }}
            showsVerticalScrollIndicator={false}
            ItemSeparatorComponent={() => <Separator size={"80%"} />}
            contentContainerStyle={{ paddingBottom: 45 }}
          />
        )}

        <Button
          square={45}
          absolute
          bottom={10}
          left={10}
          onPress={_onApply}
          icon={{ type: "antDesign", name: "check" }}
        />
      </ModalInfinityList>
    </>
  );
};

export default MultiSelector;
